import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import ReportingTypeForm from '../Forms/ReportingTypeForm';

const AddEditReportingTypeModal = ({
	dataReportingType,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Tipo de Reportabilidad
			</ModalHeader>

			<ReportingTypeForm
				dataReportingType={dataReportingType}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditReportingTypeModal;
